import { useQuery } from '@tanstack/react-query'
import type { Me } from '@one-deployment/api'
import { ApiError, get } from '@/lib/api'
import { qk } from '@/lib/query'

/** Who is signed in. `null` (not an error) when nobody is: the guard redirects. */
export async function fetchMe(): Promise<Me | null> {
  try {
    return await get<Me>('/auth/me')
  } catch (err) {
    if (err instanceof ApiError && err.status === 401) return null
    throw err
  }
}

export function useMe() {
  return useQuery({ queryKey: qk.me(), queryFn: fetchMe, staleTime: 5 * 60_000 })
}
